// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"TipoServicioAsignarPrueba_spinnerContainer__f0siV","botonAdd":"TipoServicioAsignarPrueba_botonAdd__FJioW"};